import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import getSupportedFileSelectionFilters from 'owa-fileprovider-store/lib/utils/getSupportedFileSelectionFilters';
import { getFileProviders } from 'owa-fileprovider-store/lib/selectors/getFileProviders';
import { FileProviderViewState, FileSelectionFilter } from 'owa-fileprovider-store';

export default function getAddedProviders(
    fileSelectionFilter?: FileSelectionFilter
): FileProviderViewState[] {
    const addedFileProviders = getFileProviders();

    if (fileSelectionFilter) {
        addedFileProviders.filter(
            filterForFileProviderSupportingSelectionFilter(fileSelectionFilter)
        );
    }
    return sortFileProvidersViewState(addedFileProviders);
}

function filterForFileProviderSupportingSelectionFilter(
    fileSelectionFilter: FileSelectionFilter
): (viewState: FileProviderViewState) => boolean {
    return (viewState: FileProviderViewState) => {
        const isNoneFilter = fileSelectionFilter === FileSelectionFilter.None;

        // Return true if it is a None filter, if not then check if the file provider supports that filter
        return (
            isNoneFilter ||
            getSupportedFileSelectionFilters(viewState.type).indexOf(fileSelectionFilter) !== -1
        );
    };
}

export function sortFileProvidersViewState(providers: FileProviderViewState[]) {
    const filteredProviders = providers
        .filter(p => p.type !== AttachmentDataProviderType.Mailbox)
        .filter(p => p.type !== AttachmentDataProviderType.MailMessage)
        .filter(p => !p.associatedWithPrimaryProvider);
    const primaryProviders = filteredProviders.filter(p => p.isPrimaryProvider);
    const followingPrimaryProviders = providers.filter(p => p.associatedWithPrimaryProvider);
    const alphabeticallySortedSecondaryProviders = filteredProviders
        .filter(p => !p.isPrimaryProvider)
        .sort((a, b) => a.name.localeCompare(b.name));

    // The mailbox provider is placed second to the end
    const mailboxProvider = providers.filter(p => p.type === AttachmentDataProviderType.Mailbox);

    // Mail Messages provider is placed at the end
    const mailMessageProvider = providers.filter(
        p => p.type === AttachmentDataProviderType.MailMessage
    );

    return primaryProviders
        .concat(followingPrimaryProviders)
        .concat(alphabeticallySortedSecondaryProviders)
        .concat(mailboxProvider)
        .concat(mailMessageProvider);
}
